import instance from "../components/general/AxiosInterceptor";

export const getConsultationTransactionsListApi = (data) => {
  return instance.post(`/transaction/search`, data);
};

export const annulationTransactionApi = (data) => {
  return instance.patch(`/transaction/annuler`, data);
};

export const excelExportApi = (data) => {
  return instance.post(`/transaction/exporter`, data);
};
